import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo } from 'preact/hooks';
const PreservePlanGroupNumber = ({ planGroup, value, onChange }) => {
    if (!planGroup) {
        return null;
    }
    const isReadonly = useMemo(() => {
        const { maxPurchaseNumber, minPurchaseNumber } = planGroup;
        return maxPurchaseNumber === minPurchaseNumber;
    }, [planGroup.maxPurchaseNumber, planGroup.minPurchaseNumber]);
    const helpText = useMemo(() => {
        const { maxPurchaseNumber, minPurchaseNumber } = planGroup;
        if (maxPurchaseNumber === minPurchaseNumber) {
            return _jsx(_Fragment, {}, void 0);
        }
        return _jsxs("span", { children: ["(", minPurchaseNumber, "~", maxPurchaseNumber, ")"] }, void 0);
    }, [planGroup.maxPurchaseNumber, planGroup.minPurchaseNumber]);
    const handleChange = (event) => {
        const element = event.currentTarget;
        const { minPurchaseNumber, maxPurchaseNumber } = planGroup;
        const value = parseInt(element.value);
        // 最大、最小のうちで取得されるべき値を取る
        onChange(Math.min(Math.max(isNaN(value) ? 1 : value, minPurchaseNumber), maxPurchaseNumber));
    };
    return (_jsxs("section", Object.assign({ className: "SchedulePayComponent__container" }, { children: [_jsxs("h4", Object.assign({ className: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u8CFC\u5165\u6570"] }), void 0),
            _jsxs("div", Object.assign({ className: "field control" }, { children: [_jsxs("label", Object.assign({ className: "label" }, { children: ["\u3054\u5E0C\u671B\u306E\u6570\u91CF\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", helpText] }), void 0),
                    _jsx("input", { type: "number", className: 'input mb1', max: planGroup.maxPurchaseNumber, min: planGroup.minPurchaseNumber, value: value, readonly: isReadonly, disabled: isReadonly, onChange: handleChange }, void 0),
                    isReadonly && (_jsx("small", Object.assign({ className: "is-text-danger" }, { children: "\u52A0\u76DF\u5E97\u69D8\u306E\u8A2D\u5B9A\u306B\u3088\u308A\u56FA\u5B9A\u3055\u308C\u3066\u3044\u307E\u3059" }), void 0))] }), void 0)] }), void 0));
};
export default PreservePlanGroupNumber;
